var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ll-cancel-popup-content"},[(_vm.cancelText)?_c('p',{staticClass:"ll-cancel-popup-content_text"},[_vm._v(" "+_vm._s(_vm.$t(_vm.cancelText))+" ")]):_vm._e(),_vm._t("default"),_c('div',{staticClass:"buttons"},[_vm._t("buttons")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }